module.exports = __webpack_public_path__ + "static/media/sunbit.dfe4067c.png";